// @ts-nocheck
import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { TextFieldRojo } from "../../App";
import SinapThemev2 from "../../styles/SinapThemev2";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import axios from 'axios';
import { RUTA_API_USUARIOS } from "../../Contantes/Constantes";
import { useBody } from "../../Body/state/BodyContext";
import Button from '@mui/material/Button';
import CircularProgress from "@mui/material/CircularProgress";
import { useAuth } from "../../Auth/State/AuthContext";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

export default function ModalCrearSolicitud({ open, onClose, getSolicitudes }) {
    const [destinatario, setDestinatario] = React.useState("");
    const axiosInstance = setupInterceptorsTo(axios.create());
    const { setSuccess, setMessage } = useBody();
    const { user, isLogedIn } = useAuth()
    const [loading, setLoading] = React.useState(false);

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .trim()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const enviar = async () => {
        setLoading(true)
        if (!validateEmail(destinatario)) {
            setMessage("El destinatario ingresado es invalido")
            setLoading(false)
        }
        else
            await axiosInstance({
                method: 'POST',
                url: RUTA_API_USUARIOS + '/solicitudes/registro/',
                data: {
                    nombreSolicitante: user.name,
                    emailDestinatario: destinatario
                }
            }).then(response => {
                setSuccess("La solicitud fue enviada con exito")
                getSolicitudes()
                setDestinatario("")
                onClose()
                setLoading(false)
            })
                .catch(error => {
                    setMessage("Hubo un error al querer crear la solicitud (Código de error: 00038)")
                })
    }
    const handleChange = (e) => {
        setDestinatario(e.target.value)
    }

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onClose}
        >
            <DialogContent>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    px={3}
                    py={2}
                    gap={2}
                >
                    <Typography variant="h5" align="center">
                        Enviar Solicitud
                    </Typography>

                    <Box width="100%">
                        <TextFieldRojo
                            label="Destinatario"
                            value={destinatario}
                            onChange={handleChange}
                            fullWidth
                            placeholder="Ingrese destinatario"
                        />
                    </Box>

                    {loading ? (
                        <CircularProgress color="secondary" />
                    ) : (
                        <Button variant="contained" onClick={enviar} type="button">
                            Enviar
                        </Button>
                    )}
                </Box>
            </DialogContent>
        </Dialog>
    )
}